/**
 * @description Forgot username view
 * @author Vitaliy Trush
 */

define(function(require, exports, module) {
    'use strict';

    var utils = require('utils');
    var Form = require('class/form.class');
    var user = require('user');
    var BaseView = require('common/base.view');
    var userValidationConfig = require('modules/user/user.validation.config');
    var core = require('core');

    module.exports = BaseView.extend({

        form: null,

        accessRules: {
            allow: ['guest']
        },

        events: {
            'submit .fn-forgot-username-form': 'forgotUsernameAction',
            'change #month': 'setDays',
            'change #year': 'setDays'
        },

        render: function() {
            this.$el.html(this.tmpl('forgot-username'));
            this.form = new Form(this.$('.fn-forgot-username-form'), {
                validationConfig: userValidationConfig(),
                isBirthdateRequired: true
            });

            return this;
        },

        setDays: function() {
            utils.checkBirthdate(this.$('#day'), this.$('#month'), this.$('#year'));
        },

        forgotUsernameAction: function(e) {
            e.preventDefault();

            return this.form.validate().done(function(data, form) {
                form.showLoading();
                user.forgotUsername({
                    email: data.email,
                    birthDate: data.year + '-' + data.month + '-' + data.day
                })
                    .always(form.hideLoading.bind(form))
                    .done(this.successRequest.bind(this))
                    .fail(this.errorRequest.bind(this));
            }.bind(this));
        },

        successRequest: function() {
            this.showInfo({
                content: this.translate('playtech.mobile.system.forgotUsername.success')
            });

            this.form.clear();

            core.trigger('forgotUsername:success');
        },

        errorRequest: function(response) {
            this.form.showErrorMessages({
                translation: 'playtech.mobile.system.forgotUsername.error.' + response.data.errorCode,
                content: response.data.errorMessage
            });

            core.trigger('forgotUsername:fail');
        }

    }, {
        nameOfReplacers: [
            'FORGOT_USERNAME'
        ]
    });
});